import React from 'react'
import { Link } from 'react-router-dom'
import { SCHOOL_LEGAL_PAGE_PATH } from '../constants/schoolLegal'
import { SCHOOL_LEGAL_SECTIONS } from '../content/schoolLegalContent'

type SchoolTermsAcceptanceProps = {
  accepted: boolean
  onAcceptedChange: (accepted: boolean) => void
  error?: string
  idPrefix?: string
}

const SchoolTermsAcceptance: React.FC<SchoolTermsAcceptanceProps> = ({
  accepted,
  onAcceptedChange,
  error,
  idPrefix = 'school-legal',
}) => {
  const checkboxId = `${idPrefix}-accept`

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50/80 overflow-hidden">
      <div className="px-3 py-2 border-b border-gray-200 bg-white">
        <p className="text-xs font-semibold text-gray-800">Terms of Service &amp; Privacy Policy</p>
        <p className="text-[11px] text-gray-500 mt-0.5">
          Required to register or claim your school profile.{' '}
          <Link
            to={SCHOOL_LEGAL_PAGE_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 hover:text-primary-700 font-medium underline"
          >
            Read full document
          </Link>
        </p>
      </div>

      <div className="max-h-40 overflow-y-auto px-3 py-2 text-[11px] text-gray-600 space-y-2 bg-white/60">
        {SCHOOL_LEGAL_SECTIONS.map((section) => (
          <div key={section.id}>
            <p className="font-semibold text-gray-800">{section.title}</p>
            {section.paragraphs?.map((p) => (
              <p key={p.slice(0, 40)} className="mt-0.5 leading-relaxed">
                {p}
              </p>
            ))}
            {section.bullets && section.bullets.length > 0 && (
              <ul className="mt-0.5 list-disc list-inside space-y-0.5">
                {section.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <label
        htmlFor={checkboxId}
        className="flex items-start gap-2.5 px-3 py-3 bg-white border-t border-gray-200 cursor-pointer"
      >
        <input
          id={checkboxId}
          type="checkbox"
          checked={accepted}
          onChange={(e) => onAcceptedChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        />
        <span className="text-xs text-gray-700 leading-relaxed">
          I have read and agree to the{' '}
          <Link
            to={SCHOOL_LEGAL_PAGE_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 hover:text-primary-700 font-medium underline"
            onClick={(e) => e.stopPropagation()}
          >
            Terms of Service and Privacy Policy
          </Link>
          .
        </span>
      </label>
      {error && <p className="px-3 pb-2 text-xs text-red-600">{error}</p>}
    </div>
  )
}

export default SchoolTermsAcceptance
